// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SessionInfoPanelSection .MuiDialog-container {
  height: unset !important;
  position: absolute;
  right: 0;
}
.SessionInfoPanelSection .MuiTabs-indicator {
  background: none;
}
.SessionInfoPanelSection .MuiDialog-paper {
  min-width: 770px;
  height: 100vh;
  margin: unset !important;
  max-width: unset !important;
  border-left: 1px solid #3B435E;
  background: #202437;
  box-shadow: -15px 4px 30px 0px rgba(0, 0, 0, 0.22);
}
.SessionInfoPanelSection span {
  color: rgba(255, 255, 255, 0.7);
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}
.SessionInfoPanelSection .top-container {
  margin: 14px 35px 0px;
  border-bottom: 1px solid #28304C;
}
.SessionInfoPanelSection .top-container .top-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 41px;
}
.SessionInfoPanelSection .top-container .top-wrapper .right-wrapper {
  display: flex;
  align-items: center;
}
.SessionInfoPanelSection .top-container .top-wrapper .right-wrapper .monitor {
  margin-left: 9px;
  color: white;
}
.SessionInfoPanelSection .top-container .top-wrapper .right-wrapper .image-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.SessionInfoPanelSection .top-container .top-wrapper .right-wrapper .messenger {
  margin: 0 20px;
}
.SessionInfoPanelSection .top-container .top-wrapper .right-wrapper .close-btn {
  display: flex;
  align-items: center;
  margin-left: 11px;
  cursor: pointer;
}
.SessionInfoPanelSection .top-container .top-wrapper .right-wrapper .close-btn span {
  color: white;
}
.SessionInfoPanelSection .top-container .emergency-text {
  color: white;
  font-size: 24px;
  font-weight: 500;
  font-family: "Poppins";
}
.SessionInfoPanelSection .top-container .bottom-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0 12px;
}
.SessionInfoPanelSection .top-container .bottom-wrapper .left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.SessionInfoPanelSection .top-container .bottom-wrapper .left .wait-time {
  margin-right: 14px;
}
.SessionInfoPanelSection .top-container .bottom-wrapper .left .ETA-time {
  margin-right: 12px;
}
.SessionInfoPanelSection .top-container .bottom-wrapper .left .timer {
  font-weight: 600;
}
.SessionInfoPanelSection .top-container .bottom-wrapper .right .license-plate {
  margin-right: 9px;
}
.SessionInfoPanelSection .top-container .bottom-wrapper .right .license-plate-number {
  color: #E8E8E8 !important;
}
.SessionInfoPanelSection .middle-container {
  padding: 16px 25px 0 25px;
}
.SessionInfoPanelSection .middle-container .css-1ujnqem-MuiTabs-root {
  min-height: 35px !important;
}
.SessionInfoPanelSection .middle-container .MuiTab-root {
  text-transform: none !important;
  min-height: 35px !important;
  padding: 8px 23px !important;
  width: 180px;
}
.SessionInfoPanelSection .middle-container .Mui-selected {
  border-radius: 10px 0px 0px 0px !important;
  border: 0px solid #FF8B1E !important;
  background: #3B435E !important;
}
.SessionInfoPanelSection .middle-container .Mui-selected .labelText {
  color: #fff !important;
}
.SessionInfoPanelSection .middle-container .tabCameraSection .camera-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 21.5px;
  min-height: 405px;
  border-radius: 0px 0px 10px 10px;
  width: 720px;
}
.SessionInfoPanelSection .middle-container .tabCameraSection .camera-wrapper video {
  border-radius: 0px 0px 10px 10px;
}
.SessionInfoPanelSection .middle-container .tabCameraSection .route-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 83px;
}
.SessionInfoPanelSection .middle-container .tabCameraSection .route-wrapper .route {
  font-weight: 600;
  font-size: 16px;
  line-height: 91.523%;
}
.SessionInfoPanelSection .middle-container .tabCameraSection .route-wrapper .right-route {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}
.SessionInfoPanelSection .middle-container .tabCameraSection .route-wrapper .right-route .image-route {
  width: 62px;
  margin: 0 10px;
  text-align: center;
}
.SessionInfoPanelSection .middle-container .tabCameraSection .progress-bar-warpper {
  width: 700px;
  height: 26px;
}
.SessionInfoPanelSection .middle-container .tabCameraSection .progress-bar-warpper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.03);
}
.SessionInfoPanelSection .bottom-container .assign-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  gap: 13px;
}
.SessionInfoPanelSection .bottom-container .assign-wrapper .assign-btn {
  border-radius: 10px;
  background: var(--main-orange, #FF8B1E);
  display: flex;
  width: 120px;
  text-align: center;
  height: 51px;
  align-items: center;
  justify-content: center;
}
.SessionInfoPanelSection .bottom-container .assign-wrapper .assign-btn span {
  font-size: 16px;
  font-weight: 700;
  line-height: 91.523%;
}
.SessionInfoPanelSection .bottom-container .assign-wrapper .anyone {
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: #272B3F;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 483px;
  padding: 0px 12px;
  height: 52px;
  cursor: pointer;
}
.SessionInfoPanelSection .bottom-container .assign-wrapper .anyone span {
  font-size: 16px;
  line-height: 91.523%;
}
.SessionInfoPanelSection .bottom-container .assign-wrapper .assign-to {
  font-size: 16px;
  font-weight: 600;
}

.map-wrapper {
  height: 323px;
  width: 770px;
  overflow: hidden;
}
.map-wrapper img {
  width: 100%;
}

.priority-wrapper {
  border-radius: 3px;
  background: rgba(255, 66, 89, 0.1);
  display: flex;
  align-items: center;
  width: 87px;
  height: 31px;
  justify-content: center;
  gap: 3.814px;
}
.priority-wrapper .circle-icon {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #FF4259;
}
.priority-wrapper .priority {
  font-weight: 700;
  font-family: "Manrope";
  font-weight: 700;
  line-height: 27.966px;
  color: #FF4259;
}

.priority-wrapper.medium {
  background: rgba(255, 139, 30, 0.1);
}
.priority-wrapper.medium .circle-icon {
  background: #FF8B1E;
}
.priority-wrapper.medium .priority {
  color: #FF8B1E;
}

.priority-wrapper.low {
  background: rgba(88, 218, 120, 0.1);
}
.priority-wrapper.low .circle-icon {
  background: #58DA78;
}
.priority-wrapper.low .priority {
  color: #58DA78;
}

.white-text {
  color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/SessionInfoPanelSection/styles.scss"],"names":[],"mappings":"AACI;EACI,wBAAA;EACA,kBAAA;EACA,QAAA;AAAR;AAGI;EACI,gBAAA;AADR;AAII;EACI,gBAAA;EACA,aAAA;EACA,wBAAA;EACA,2BAAA;EACA,8BAAA;EACA,mBAAA;EACA,kDAAA;AAFR;AAKI;EACI,+BAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAHR;AAMI;EACI,qBAAA;EACA,gCAAA;AAJR;AAMQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAJZ;AAMY;EACI,aAAA;EACA,mBAAA;AAJhB;AAMgB;EACI,gBAAA;EACA,YAAA;AAJpB;AAOgB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALpB;AAQgB;EACI,cAAA;AANpB;AASgB;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAPpB;AASoB;EACI,YAAA;AAPxB;AAaQ;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAXZ;AAcQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AAZZ;AAcY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAZhB;AAcgB;EACI,kBAAA;AAZpB;AAegB;EACI,kBAAA;AAbpB;AAgBgB;EACI,gBAAA;AAdpB;AAmBgB;EACI,iBAAA;AAjBpB;AAoBgB;EACI,yBAAA;AAlBpB;AAwBI;EACI,yBAAA;AAtBR;AAwBQ;EACI,2BAAA;AAtBZ;AAyBQ;EACI,+BAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;AAvBZ;AA0BQ;EACI,0CAAA;EACA,oCAAA;EACA,8BAAA;AAxBZ;AA0BY;EACI,sBAAA;AAxBhB;AA6BY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gCAAA;EACA,YAAA;AA3BhB;AA6BgB;EACI,gCAAA;AA3BpB;AA+BY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA7BhB;AA+BgB;EACI,gBAAA;EACA,eAAA;EACA,oBAAA;AA7BpB;AAgCgB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AA9BpB;AAgCoB;EACI,WAAA;EACA,cAAA;EACA,kBAAA;AA9BxB;AAmCY;EACI,YAAA;EACA,YAAA;AAjChB;AAmCgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AAjCpB;AAwCQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;AAtCZ;AAwCY;EACI,mBAAA;EACA,uCAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAtChB;AAwCgB;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;AAtCpB;AA0CY;EACI,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AAxChB;AA0CgB;EACI,eAAA;EACA,oBAAA;AAxCpB;AA4CY;EACI,eAAA;EACA,gBAAA;AA1ChB;;AAiDA;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AA9CJ;AAgDI;EACI,WAAA;AA9CR;;AAkDA;EACI,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;AA/CJ;AAiDI;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AA/CR;AAkDI;EACI,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AAhDR;;AAoDA;EACI,mCAAA;AAjDJ;AAmDI;EACI,mBAAA;AAjDR;AAoDI;EACI,cAAA;AAlDR;;AAsDA;EACI,mCAAA;AAnDJ;AAqDI;EACI,mBAAA;AAnDR;AAsDI;EACI,cAAA;AApDR;;AAwDA;EACI,sBAAA;AArDJ","sourcesContent":[".SessionInfoPanelSection {\n    .MuiDialog-container {\n        height: unset !important;\n        position: absolute;\n        right: 0;\n    }\n\n    .MuiTabs-indicator {\n        background: none;\n    }\n\n    .MuiDialog-paper {\n        min-width: 770px;\n        height: 100vh;\n        margin: unset !important;\n        max-width: unset !important;\n        border-left: 1px solid #3B435E;\n        background: #202437;\n        box-shadow: -15px 4px 30px 0px rgba(0, 0, 0, 0.22);\n    }\n\n    span {\n        color: rgba(255, 255, 255, 0.70);\n        font-family: 'Poppins';\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 140%;\n    }\n\n    .top-container {\n        margin: 14px 35px 0px;\n        border-bottom: 1px solid #28304C;\n\n        .top-wrapper {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            min-height: 41px;\n\n            .right-wrapper {\n                display: flex;\n                align-items: center;\n\n                .monitor {\n                    margin-left: 9px;\n                    color: white;\n                }\n\n                .image-wrapper {\n                    width: 24px;\n                    height: 24px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                }\n\n                .messenger {\n                    margin: 0 20px;\n                }\n\n                .close-btn {\n                    display: flex;\n                    align-items: center;\n                    margin-left: 11px;\n                    cursor: pointer;\n\n                    span {\n                        color: white;\n                    }\n                }\n            }\n        }\n\n        .emergency-text {\n            color: white;\n            font-size: 24px;\n            font-weight: 500;\n            font-family: 'Poppins';\n        }\n\n        .bottom-wrapper {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding: 12px 0 12px;\n\n            .left {\n                display: flex;\n                align-items: center;\n                gap: 12px;\n\n                .wait-time {\n                    margin-right: 14px;\n                }\n\n                .ETA-time {\n                    margin-right: 12px;\n                }\n\n                .timer {\n                    font-weight: 600;\n                }\n            }\n\n            .right {\n                .license-plate {\n                    margin-right: 9px;\n                }\n\n                .license-plate-number{\n                    color: #E8E8E8 !important;\n                }\n            }\n        }\n    }\n\n    .middle-container {\n        padding: 16px 25px 0 25px;\n\n        .css-1ujnqem-MuiTabs-root {\n            min-height: 35px !important;\n        }\n\n        .MuiTab-root {\n            text-transform: none !important;\n            min-height: 35px !important;\n            padding: 8px 23px !important;\n            width: 180px;\n        }\n\n        .Mui-selected {\n            border-radius: 10px 0px 0px 0px !important;\n            border: 0px solid #FF8B1E !important;\n            background: #3B435E !important;\n\n            .labelText {\n                color: #fff !important;\n            }\n        }\n\n        .tabCameraSection {\n            .camera-wrapper {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                margin-bottom: 21.5px;\n                min-height: 405px;\n                border-radius: 0px 0px 10px 10px;\n                width: 720px;\n\n                video {\n                    border-radius: 0px 0px 10px 10px;\n                }\n            }\n\n            .route-wrapper {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                gap: 83px;\n\n                .route {\n                    font-weight: 600;\n                    font-size: 16px;\n                    line-height: 91.523%;\n                }\n\n                .right-route {\n                    display: flex;\n                    align-items: center;\n                    justify-content: space-between;\n                    gap: 4px;\n\n                    .image-route {\n                        width: 62px;\n                        margin: 0 10px;\n                        text-align: center;\n                    }\n                }\n            }\n\n            .progress-bar-warpper {\n                width: 700px;\n                height: 26px;\n\n                img {\n                    width: 100%;\n                    height: 100%;\n                    object-fit: cover;\n                    transform: scale(1.03);\n                }\n            }\n        }\n    }\n\n    .bottom-container {\n        .assign-wrapper {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding: 14px 18px;\n            gap: 13px;\n\n            .assign-btn {\n                border-radius: 10px;\n                background: var(--main-orange, #FF8B1E);\n                display: flex;\n                width: 120px;\n                text-align: center;\n                height: 51px;\n                align-items: center;\n                justify-content: center;\n\n                span {\n                    font-size: 16px;\n                    font-weight: 700;\n                    line-height: 91.523%;\n                }\n            }\n\n            .anyone {\n                border-radius: 10px;\n                border: 1px solid rgba(255, 255, 255, 0.20);\n                background: #272B3F;\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                width: 483px;\n                padding: 0px 12px;\n                height: 52px;\n                cursor: pointer;\n\n                span {\n                    font-size: 16px;\n                    line-height: 91.523%;\n                }\n            }\n\n            .assign-to {\n                font-size: 16px;\n                font-weight: 600;\n            }\n\n        }\n    }\n}\n\n.map-wrapper {\n    height: 323px;\n    width: 770px;\n    overflow: hidden;\n\n    img {\n        width: 100%;\n    }\n}\n\n.priority-wrapper {\n    border-radius: 3px;\n    background: rgba(255, 66, 89, 0.10);\n    display: flex;\n    align-items: center;\n    width: 87px;\n    height: 31px;\n    justify-content: center;\n    gap: 3.814px;\n\n    .circle-icon {\n        width: 5px;\n        height: 5px;\n        border-radius: 50%;\n        background: #FF4259;\n    }\n\n    .priority {\n        font-weight: 700;\n        font-family: 'Manrope';\n        font-weight: 700;\n        line-height: 27.966px;\n        color: #FF4259;\n    }\n}\n\n.priority-wrapper.medium {\n    background: rgba(255, 139, 30, 0.10);\n\n    .circle-icon {\n        background: #FF8B1E;\n    }\n\n    .priority {\n        color: #FF8B1E;\n    }\n}\n\n.priority-wrapper.low {\n    background: rgba(88, 218, 120, 0.10);\n\n    .circle-icon {\n        background: #58DA78;\n    }\n\n    .priority {\n        color: #58DA78;\n    }\n}\n\n.white-text {\n    color: #fff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
